import React, { useEffect, useRef, useState } from 'react';
import './index.scss'

const ResultItem = ({ result }) => (
  <li className="search-engine__results-item" key={result.url}>
    <a href={result.url}>
      <h6>{result.raw.title.replace(" | Power Switch Action", "")}</h6>
      <p>{result.raw.body}</p>
    </a>
  </li>
)

export default function SearchEngine ({ searchEngineVisible, setSearchEngineVisible }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [client, setClient] = useState(null);
  const inputEl = useRef(null);

  // = = = = = = = = = = = = =
  // Hooks

  useEffect(() => {
    if (typeof window !== 'undefined') {
      createDatoCmsSearchClient()
    }
  }, [])

  useEffect(() => {
    if (typeof window !== 'undefined' || !client) {
      client
        ?.search(query, { limit: 100, highlightWith: '<span class="h"></span>' })
        .then(function(response) {
          setResults(response.results)
        })
        .catch(function(error) {
          console.error(error)
        })
    }
  }, [query])


  // = = = = = = = = = = = = =
  // Event Handlers

  const createDatoCmsSearchClient = async () => {
    const DatoCmsSearch = (await import('datocms-search/dist/datocms-search.base.js')).default;
  
    const datoClient = new DatoCmsSearch("8ddcc2689975596fc7cb09f515178b");
    setClient(datoClient);
  };

  const handleChange = e => {
    setQuery(e.target.value);
  }

  const handleSubmit = e => {
    e.preventDefault();
    // `inputEl.current` points to the mounted search input element
    const q = inputEl.current.value;
  }
  
  
  return (
    <section className={`search-engine ${searchEngineVisible ? 'search-engine--visible' : null}`}>

      <div className="search-engine__close-icon" onClick={() => setSearchEngineVisible(false)}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_2912_30965)">
          <path d="M3.77817 4.22183L11.5563 12M19.3345 19.7782L11.5563 12M11.5563 12L3.77817 19.7782M11.5563 12L19.3345 4.22183" stroke="white" strokeWidth="4" strokeLinecap="round"/>
          </g>
          <defs>
          <clipPath id="clip0_2912_30965">
          <rect width="24" height="24" fill="white"/>
          </clipPath>
          </defs>
        </svg>
      </div>

      <div className="search-engine__content">
        <h2 className="search-engine__headline">Search this website</h2>
        <form onSubmit={(e) => handleSubmit(e)} className="search-engine__form">
          <label htmlFor="search-input" style={{ display: "none" }}>
            Search for:
          </label>
          <div className="search-engine__search-input">
            <input
              ref={inputEl}
              type="search"
              id="search-input"
              value={query}
              placeholder="ie: projects"
              onChange={handleChange}
            />
          </div>
        </form>
        <div className={`search-engine__results ${(results.length > 0 || query.length > 5) ? 'search-engine__results--active' : null}`}>
          {
            results.length > 0 &&
            <ul className="search-engine__results-list">
              {
                results?.map(result => <ResultItem result={ result } />)
              }
            </ul>
          }
          {
            (results.length === 0 && query.length > 5) &&
            <p className="search-engine__message">Sorry, no results found. Try a different search</p>
          }
        </div>
      <div className="margin-bottom-hack">.</div>
      </div>
    </section>
  )
}